import { useContext } from "react";
import { AccordionContext } from "../providers";

export function useAccordion() {
  return useContext(AccordionContext);
}
